// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"keto-textarea_wrapper__QNi5W","input":"keto-textarea_input___LrZ7","input_error":"keto-textarea_input_error__ss_I9","error":"keto-textarea_error__1rRju"};